<div *ngIf="listItem" class="event-row center75 noselect"
     [class.is-selected]="listItem.isSelected"
     (click)="itemOpen()"
     (touchstart)="setIsSelected(true)" (touchend)="setIsSelected(false)" (touchmove)="setIsSelected(false)"
>
  <div class="event-activity-icon">
    <span *ngIf="listItem.type === 'play_config_update'">🕐‍</span>
    <span *ngIf="listItem.type === 'help_request'">🙇‍</span>
    <span *ngIf="listItem.type === 'help_response'">🙋‍♂️</span>
    <span *ngIf="listItem.type === 'trainer_booking_add'">🎓</span>
    <span *ngIf="listItem.type === 'booking_add'">📆</span>
    <span *ngIf="listItem.type === 'booking_cancel'">❌</span>
    <span *ngIf="listItem.type === 'trainer_booking_cancel'">❌</span>
    <span *ngIf="listItem.type === 'tcs_confirmation'">📝</span>
    <span *ngIf="listItem.type === 'event_checkin'">✅</span>
    <span *ngIf="listItem.type === 'event_subscription_opened'">📢</span>
<!--    <span *ngIf="listItem.type === 'squashtime_game_finish'">🎾</span>-->
<!--    <span *ngIf="listItem.type === 'game_finish'">🎾</span>-->
    <span *ngIf="listItem.type === 'tournament_game_proposal'">🏆</span>
    <span *ngIf="listItem.type === 'game_proposal'">🎾</span>
    <span *ngIf="listItem.type === 'broadcast'">📢</span>
<!--    <span *ngIf="listItem.type === 'class_create'">👥</span>-->
    <span *ngIf="listItem.type === 'friendship_confirmed'">👥</span>
    <span *ngIf="listItem.type === 'friendship_request'">👥</span>
    <span *ngIf="listItem.type === 'friendship_approve'">👥</span>
    <span *ngIf="listItem.type === 'class_join'">👥</span>
    <span *ngIf="listItem.type === 'class_add'">👥</span>
    <span *ngIf="[
    'play_config_update','help_request','help_response',
    'trainer_booking_add','booking_add','booking_cancel','trainer_booking_cancel',
    'tcs_confirmation','event_checkin','tournament_game_proposal','game_proposal',
    'broadcast', 'event_subscription_opened',
    'friendship_confirmed', 'friendship_request', 'friendship_approve', 'class_join', 'class_add'
    ].indexOf(listItem.type) === -1">🆕️</span>
  </div>
  <div class="event-date event-date-start" *ngIf="listItem.itemFullData['payload_parsed']['event_timestamp']">
    🚩 {{listItem.itemFullData['payload_parsed']['event_timestamp']*1000 | fsDate}}
  </div>
  <div class="event-date event-date-end" *ngIf="listItem.itemFullData['payload_parsed']['event_timestamp'] && listItem.itemFullData['payload_parsed']['event_duration']">
    🏁 {{(listItem.itemFullData['payload_parsed']['event_timestamp'] + listItem.itemFullData['payload_parsed']['event_duration'])*1000 | fsDate}}
  </div>
  <div class="event-date">
    {{listItem.cdate | fsDate}}
  </div>

  <div class="event-user-icon smaller-badge"
       matBadge="{{profileLeft['cup_position'] ? profileLeft['cup_position'] : profileLeft['rank']}}" matBadgeColor="accent">
    <img src="{{profileLeft['picture_src_preview']}}"
         alt="{{profileLeft['shipping_name']}}" title="{{profileLeft['shipping_name']}}"
         style="{{ profileLeft['sex']==='F' ? 'border-color: #FF1744' : 'border-color: #448AFF' }}"
    />
  </div>

  <ng-container *ngIf="state === 'split'">
    <ng-container *ngIf="['game_proposal','tournament_game_proposal'].includes(this.eventPayload['type'])">
      <div class="event-score">
        <div *ngIf="this.eventPayload['status']==='confirmed'">{{this.eventPayload['score']}}</div>
        <div *ngIf="this.eventPayload['status']==='canceled'">❌</div>
        <div *ngIf="['proposal','pending','score_confirmation'].indexOf(this.eventPayload['status'])!==-1">⏳</div>
      </div>

      <div class="event-name" class="event-name-split">
        {{'game_status_'+this.eventPayload['status'] | GetLabelPipe}}
      </div>
    </ng-container>
    <ng-container *ngIf="['trainer_booking_add'].includes(this.eventPayload['type'])">
      <div class="event-score">
        <div>{{application.account.payload_parsed['connect_game_icon']}}</div>
      </div>

      <div class="event-name" class="event-name-split">
<!--        {{'trainer_booking_add_label' | GetLabelPipe}}-->
<!--        {{application.account.payload_parsed['labels']['training']}}-->
        {{'training' | GetLabelPipe}}
      </div>
    </ng-container>
    <ng-container *ngIf="['trainer_booking_cancel'].includes(this.eventPayload['type'])">
      <div class="event-score">
        <div>❌</div>
      </div>

      <div class="event-name" class="event-name-split">
<!--        {{'trainer_booking_cancel_label' | GetLabelPipe}}-->
        {{'canceled' | GetLabelPipe}}
      </div>
    </ng-container>

    <div class="event-user-icon event-user-icon-split smaller-badge"
         matBadge="{{profileRight['cup_position'] ? profileRight['cup_position'] : profileRight['rank']}}" matBadgeColor="accent">
      <img src="{{profileRight['picture_src_preview']}}"
           alt="{{profileRight['shipping_name']}}" title="{{profileRight['shipping_name']}}"
           style="{{ profileRight['sex']==='F' ? 'border-color: #FF1744' : 'border-color: #448AFF' }}"
      />
    </div>
  </ng-container>

  <div class="event-name" *ngIf="listItem.type === 'play_config_update'">
    <div>{{'play_config_update_label' | GetLabelPipe}}</div>
<!--    <div>{{'play_config_update_label' | GetLabelPipe}}-->
<!--      {{listItem['itemFullData']['payload_parsed'].play_conf?.weekdays}}-->
<!--      {{listItem['itemFullData']['payload_parsed'].play_conf?.weekends}}-->
<!--    </div>-->
    <div class="event-row-description-line">
      <ng-container *ngIf="!listItem.itemFullData['payload_parsed'].play_conf?.weekdays && !listItem.itemFullData['payload_parsed'].play_conf?.weekends">
        {{'play_conf_not_set' | GetLabelPipe}}<br/>
      </ng-container>
      <ng-container *ngIf="listItem.itemFullData['payload_parsed'].play_conf?.weekdays">
        {{'weekdays_range'|GetLabelPipe}}: {{listItem.itemFullData['payload_parsed'].play_conf.weekdays | PlayConfigLabelPipe}}<br/>
      </ng-container>
      <ng-container *ngIf="listItem.itemFullData['payload_parsed'].play_conf?.weekends">
        {{'weekends_range'|GetLabelPipe}}: {{listItem.itemFullData['payload_parsed'].play_conf.weekends | PlayConfigLabelPipe}}<br/>
      </ng-container>
    </div>
  </div>
  <div class="event-name" *ngIf="listItem.type === 'help_request'">
    <div>{{'help_request_label' | GetLabelPipe}} {{listItem['itemFullData']['payload_parsed']['message']}}</div>
    <div class="event-row-description-line">{{'date_and_time' | GetLabelPipe}}: {{listItem['itemFullData']['payload_parsed']['event_timestamp']*1000 | fsDate}}</div>
  </div>
  <div class="event-name" *ngIf="listItem.type === 'help_response'">
    <div>{{'help_response_label' | GetLabelPipe}} {{listItem['itemFullData']['payload_parsed']['message']}}</div>
    <div class="event-row-description-line">{{'date_and_time' | GetLabelPipe}}: {{listItem['itemFullData']['payload_parsed']['event_timestamp']*1000 | fsDate}}</div>
  </div>

  <div class="event-name" *ngIf="listItem.type === 'booking_add' || listItem.type === 'booking_cancel'">
    <div>{{listItem['name']}}</div>
    <div class="event-row-description-line">{{'date_and_time' | GetLabelPipe}}: {{listItem['itemFullData']['payload_parsed']['event_timestamp']*1000 | fsDate}}</div>
  </div>
  <div class="event-name" *ngIf="listItem.type === 'tcs_confirmation'">
    {{'tcs_confirmation_label' | GetLabelPipe}}
  </div>
  <div class="event-name" *ngIf="listItem.type === 'class_add'">
    {{'class_add_label' | GetLabelPipe}} "{{listItem['itemFullData']['payload_parsed']['class_name']}}"
  </div>
  <div class="event-name" *ngIf="listItem.type === 'class_join'">
    {{'class_join_label' | GetLabelPipe}} "{{listItem['itemFullData']['payload_parsed']['class_name']}}"
  </div>
  <div class="event-name" *ngIf="state !== 'split' && !['play_config_update','help_request','help_response','tcs_confirmation','booking_add','booking_cancel','class_add','class_join'].includes(listItem.type)">
    {{listItem['name']}}
  </div>

</div>
